import Alert from "@/components/ui/Alert/Alert";
import { dataProps } from "@/models/data.model";
import { ComponentType, FC, JSX } from "react";

import { LeaderboardSize } from "./LeaderboardPage.types";

type Props = dataProps & {
  UI: ComponentType<{ leaderboardSize: LeaderboardSize; data: dataProps }>;
  withTopThree?: boolean;
};

const LeaderboardPage: FC<Props> = ({
  UI,
  withTopThree = true,
  ...data
}): JSX.Element => {
  const { leaderboard } = data as dataProps;

  if (leaderboard.error) {
    return <Alert>Failed to load leaderboard.</Alert>;
  }

  const length = leaderboard.length;

  if (length === 0) {
    return <UI leaderboardSize="empty" data={data as dataProps} />;
  }

  const leaderboardSize: LeaderboardSize =
    withTopThree && length <= 3 ? "topthree" : "full";

  return <UI leaderboardSize={leaderboardSize} data={data as dataProps} />;
};

export default LeaderboardPage;
